import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=424b24b1"
import script from "./not-found.vue?vue&type=script&lang=ts"
export * from "./not-found.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports